import { Dropdown, Button, Form } from '@bynder/design-system';
import { DEFAULT_STYLE } from '../../shared/styled-components/constants';
import React from 'react';

const FontStyleDropdown: React.FC<{
  options: string[];
  selectedValue: string | null;
  newValueSelectedFn: (value: string) => void;
}> = ({ options, selectedValue, newValueSelectedFn }) => (
  <>
    <Dropdown
      trigger={({ isOpen, ...triggerProps }) => (
        <Button
          variant="secondary"
          isPressed={isOpen}
          rightIcon={<Dropdown.Arrow />}
          isFullWidth
          {...triggerProps}
        >
          <Dropdown.SelectButtonText>
            {options.includes(selectedValue) ? selectedValue : DEFAULT_STYLE}
          </Dropdown.SelectButtonText>
        </Button>
      )}
    >
      {options.map((option: string) => {
        return (
          <Dropdown.Item
            key={option}
            isChecked={selectedValue === option}
            onClick={() => newValueSelectedFn(option)}
          >
            {option}
          </Dropdown.Item>
        );
      })}
    </Dropdown>
    {!selectedValue && <Form.HelperText isInvalid>Select one</Form.HelperText>}
  </>
);

export default FontStyleDropdown;
